import { createApp } from 'vue'
import router from './router'
import store from './store/index.js'
import broadcasts from '../common/broadcasts.js'
import IdleVue from 'idle-vue'
import EventBus from '../common/event-bus.js'

const app = createApp({})

app.use(router)
app.use(store)
app.use(IdleVue, {
  eventEmitter: EventBus,
  idleTime: 1620000, // 27 minutes (1620000 milliseconds),
  events: ['keydown', 'mousedown', 'touchstart'],
})

app.mount('#app')

// Google Analytics pageview tracking.
if (window.location.hostname === 'energypricebook.com') {
  ga('set', 'page', router.currentRoute.path)
  ga('send', 'pageview')

  router.afterEach((to, from) => {
    ga('set', 'page', to.path)
    ga('send', 'pageview')
  })
}
